module.exports = __webpack_public_path__ + "fonts/Poppins-Thin.c0fafa83.ttf";